import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import { post } from './axios';

const presignedUrl = '/api/presigned-url';
const ackPresignedUrl = '/api/presigned-url/ack';

export const uploadMultiToFolder = async (
  folder: string,
  files: any[],
  userId: number
): Promise<any> => {
  const data: any = new FormData();
  data.append('folder', folder);
  const filenames: any[] = files.map((f) => f.name);
  const map = files.reduce((result, x) => {
    result[x.name] = x;
    return result;
  }, {});
  data.append('files', filenames);
    const { data: presignedUrls } = await post(presignedUrl, data);
  const uploadedFiles = await Promise.all(
    Object.keys(presignedUrls).map(async (name) => {
      const { key, url, code } = presignedUrls[name];
      const file = map[name];
      const options = { headers: { 'Content-Type': file.type } };
      await axios.put(url, file, options);
      return { key, name, code };
    })
  );
    return post(ackPresignedUrl, {
    folder,
    userId,
    files: uploadedFiles,
  });
};

export const uploadFiles = (
  objectCode: number | null,
  files: any[],
  name: string,
  userId: number,
  folderPath: string
) => {
  const targetFiles = Array.isArray(files) ? files : [files];
  let filesList = targetFiles.filter((f) => f.id);

  const newFiles = targetFiles.filter((f) => !f.id);
  if (newFiles && newFiles.length === 0) {
    return Promise.resolve({ name: name, filesList });
  }
  console.log('Files will be uploaded', newFiles);

  const idFolder = objectCode ? `${folderPath}/${objectCode}` : `${folderPath}/temp/${uuidv4()}`;

  return uploadMultiToFolder(idFolder, newFiles, userId)
    .then((res) => {
      const { data } = res;
      const uploadedFiles = Object.values(data.photoIds);

      const savedPhotos =
        targetFiles.filter((f) => f.id && uploadedFiles.findIndex((p: any) => p.id === f.id) < 0) ||
        [];

      filesList = uploadedFiles.concat(savedPhotos);
      return { name: name, filesList };
    })
    .catch((err) => {
      console.error(err);
      return { name: name, filesList };
    });
};
